var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('client-form',{on:{"submited":_vm.form_submited}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }